<template>
     <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="m-t-0">Trusted &amp; Used By</h2>
          </div>
        </div>
        <div class="row logos clearfix">
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_DGMC.png">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Netcare.jpg">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_CMSA.png">
          </div>
        </div>
        <div class="row logos clearfix">
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Medemass.png">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Lancet.jpg">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Ampath.png">
          </div>
        </div>
        <div class="row logos clearfix">
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Vericlaim.jpg">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Promed.jpg">
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_Healthrad.jpg">
          </div>
        </div>
        <div class="row logos clearfix">
          <div class="col-md-4 text-center">
              <!--left space holder for logo -->
          </div>
          <div class="col-md-4 text-center">
            <img src="~assets/images/brochure/professional/TrustBy_GoodX.png">
          </div>
          <div class="col-md-4 text-center">
              <!--right space holder for logo -->
          </div>
        </div>
        <div class="row m-t-lg">
          <div class="col-md-6 col-md-offset-3 text-center">
            <p>LogBox integrates with many platforms and billing systems. If you are a software provider in the medical field, please contact us to find out how we can partner together.</p>
            <p class="m-b-0"><u><b><a href="mailto:partner@logbox.co.za">Partner with us</a></b></u></p>
          </div>
        </div>
      </div>
</template>
<script>
  export default {
    name: 'partnerBranding',
  };

</script>



// WEBPACK FOOTER //
// PartnerBranding.vue?50460c0e